<div mat-dialog-title>
  <h2>{{ 'historyStatus.header' | transloco }}</h2>
  <button class="close-btn ms-auto" data-test="statusHistory_btn-close" mat-dialog-close></button>
</div>

<div mat-dialog-content class="m-1 status-history-content zit-scrollbar">
  <mat-table [dataSource]="historyStatusPaginated">
    <ng-container matColumnDef="status">
      <mat-header-cell class="mx-2 td-status" *matHeaderCellDef>{{ 'historyStatus.status' | transloco }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="td-status">
        <div class="ring-status">
          <svg-icon [key]="getStatusClass(element.statusId)" class="mt-2 me-2 float-start"></svg-icon>
          <div>{{ getActiveLang() == 'ru' ? element.name : element?.nameEn }}</div>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="data">
      <mat-header-cell *matHeaderCellDef class="td-createdat">{{ 'historyStatus.data' | transloco }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="td-createdat">
        {{ element.createdAt | date: 'dd.MM.YYYY HH:mm:ss' }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="izm" *ngIf="!!editedby">
      <mat-header-cell *matHeaderCellDef class="td-editedby">Кто изменил</mat-header-cell>
      <mat-cell *matCellDef="let element" class="td-editedby">{{ element.accountName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="clientName">
      <mat-header-cell *matHeaderCellDef>ИС</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.clientName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="comment">
      <mat-header-cell *matHeaderCellDef>{{ 'historyStatus.komment' | transloco }}</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.reason }}</mat-cell>
    </ng-container>
    <mat-header-row class="mat-header-row-sticky" *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
  <mat-paginator
    data-test="statusHistory_paginator"
    [ngClass]="{ 'd-none': total <= minPageSize }"
    showFirstLastButtons
    [pageIndex]="pageIdx"
    [pageSize]="pageSize"
    [pageSizeOptions]="defaultPageSizeOptions"
    (page)="getData($event)"
  ></mat-paginator>
</div>
